const { DateTime } = require('luxon');

export const convertISOtoLocaleString = date => DateTime.fromISO(date).toFormat('MM/dd/yyyy');
